"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = TextItalic;
var _TextItalic = require("@adobe/react-spectrum-workflow/dist/TextItalic.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function TextItalic(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_TextItalic.A4uTextItalic, null));
}